<template>
    <div class="container">
      <el-row>
        <el-col :span="24">
          <div class="banner">
            <el-carousel :interval="5000" arrow="always">
              <el-carousel-item v-for="item in bannerList" :key="item.id">
                <img style="width: 100%;height: 100%;" :src="item" alt="">
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
      </el-row>
      <div class="mainBox">
        <el-menu  :default-active="activeIndex" class="el-menu-demo mainBox1" mode="horizontal" @select="handleSelect">
          <el-menu-item class="meItem" style="font-size: 20px;font-weight: 550;color: black;&:hover{color: red !important;}" v-for="item in barList" @click="toItemList(item)" v-show="item.lmName !== '名医名家'" :key="item.id" index="item.id">{{item.lmName}}</el-menu-item>
          <el-dropdown @command="toGzs()">
            <el-menu-item class="meItem" style="font-size: 20px;font-weight: 550;color: black;&:hover{color: red !important;}" @click="toItemList({id:5})">名医名家</el-menu-item>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>王锋国医传承工作室</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-menu>
        <div class="mainBox2">
          <div class="mainBox2_1">
            <div class="mainBox2_1_1">
              <div style="position: absolute;left: 12%;font-size: 28px;font-weight: 600;">新闻动态</div>
              <div style="position: absolute;left: 30%;font-size: 22px;font-weight: 600;">News Center</div>
              <div @click="toItemList({id:3})" style="position: absolute;right: 10%;font-size: 22px;font-weight: 600;cursor: pointer;">更多>></div>
            </div>
            <div class="mainBox2_1_2" style="margin-top: 20px;">
              <div class="m_left">
                
              </div>
              <div class="m_right">
                <div class="m_right_l">
                  <img @click="toItemInfo(xwData)" style="cursor: pointer;" v-if="xwData.imgUrl2" :src="toUrl2(xwData.imgUrl2)" alt="">
                  <img @click="toItemInfo(xwData)" style="cursor: pointer;" v-else :src="xwData.imgUrl" alt="">
                  <div class="imTitle">
                    {{ xwData.title }}
                  </div>
                </div>
                <div class="m_right_r">
                  <div class="m_item" v-for="(item,index) in xwdtList" @click="toItemInfo(item)" :key="index">
                    <div style="display: flex;align-items: center;width:70%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                      <img src="../assets/images/list/news-icon.png" alt="">
                      <div style="width:90%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ item.title }}</div>
                    </div>
                    <div>{{ spDate(item.createTime) }}</div>
                  </div>  
                </div>
              </div>
            </div>
            <div class="mainBox2_1_3" style="margin-top: 20px;">
              <div class="m_left"></div>
              <div class="m_right">
                <div class="djBox" style="margin-left: -20px;">
                  <div class="title">党建社群</div>
                  <div v-for="(item,index) in djsqList" @click="toItemInfo(item)" :key="index" class="djItem">
                    <div class="djItem-1">
                      <img src="../assets/images/list/news-icon.png" alt="">
                      <div style="width:96%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ item.title }}</div>
                    </div>
                    <div>{{ spDate2(item.createTime) }}</div>
                  </div>
                </div>
                <div class="djBox">
                  <div class="title">科研教学</div>
                  <div v-for="(item,index) in kyjxList" :key="index" class="djItem" @click="toItemInfo(item)">
                    <div class="djItem-1">
                      <img src="../assets/images/list/news-icon.png" alt="">
                      <div style="width:96%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ item.title }}</div>
                    </div>
                    <div>{{ spDate2(item.createTime) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mainBox2_2">
              <div class="bo2_ti">
                <div style="font-size: 28px;">通知公告</div>
                <div style="font-size: 22px;cursor: pointer;" @click="toItemList({id:11})">更多>></div>
              </div>
              <div class="bo2_m">
                <div class="bo2Item" v-for="(item,index) in tzggList" @click="toItemInfo(item)" :key="index">
                  <div class="bo2ItemTitle">{{ item.title }}</div>
                  <div class="bo2ItemMain">{{ spDate2(item.createTime) }}</div>
                </div>
              </div>
              <div class="bo2_ti">
                <div style="font-size: 28px;">视频中心</div>
                <div style="font-size: 22px;cursor: pointer;" @click="toItemList({id:17})">更多>></div>
              </div>
              <div class="bo2_s" v-if="videe1">
                <!-- <iframe :src="videe" style="width: 100%;height: 100%;" frameborder="0" allowfullscreen></iframe> -->
                <video :src="videe1" style="width: 100%;height: 100%;" preload :autoplay="false" controls controlslist="noplaybackrate noplaybackrate "></video>
              </div>
              <div class="bo2_s" v-if="videe2">
                <iframe :src="videe2" style="width: 100%;height: 100%;" frameborder="0" allowfullscreen></iframe>
               
              </div>
          </div>
        </div>
        <div class="mainBox3">
          <div style="width: 12%;border-right: 2px dashed #881F0C;">
            <img src="../assets/images/shou/keshi.jpg" alt="">
          </div>
          <div class="mainBox3Box" style="width: 20%;border-right: 2px dashed #881F0C;">
            <div class="title">内科系列</div>
            <div class="mainBox3BoxMain1">
              <div v-for="(item,index) in nkList" @click="toItemInfo(item)" :key="index">{{ item.title }}</div>
              <!-- <el-row>
                <el-col v-for="(item,index) in nkList" :key="index" :span="24">{{ item.title }}</el-col>
              </el-row> -->
            </div>
          </div>
          <div class="mainBox3Box" style="width: 20%;border-right: 2px dashed #881F0C;">
            <div class="title">外科系列</div>
            <div class="mainBox3BoxMain2">
              <div v-for="(item,index) in wkList" @click="toItemInfo(item)" :key="index">{{ wkSp(item.title) }}</div>
            </div>
          </div>
          <div class="mainBox3Box" style="width: 24%;border-right: 2px dashed #881F0C;">
            <div class="title">骨科系列</div>
            <div class="mainBox3BoxMain3">
              <div v-for="(item,index) in gkList" @click="toItemInfo(item)" :key="index">{{ gkSp(item.title) }}</div>
            </div>
          </div>
          <div class="mainBox3Box" style="width: 22%;">
            <div class="title">其他科室</div>
            <div class="mainBox3BoxMain4">
              <div v-for="(item,index) in qtkList" @click="toItemInfo(item)" :key="index">{{ qtSp(item.title) }}</div>
            </div>
          </div>
        </div>
        <div class="mainBox4">
          <div style="display: flex;align-items: center;margin-left: 70px;margin-top: 10px;">
            <div style="font-size: 28px;">就医指南</div>
            <div style="font-size: 22px;margin-left: 20px">Patients Guide</div>
          </div>
          <div style="font-size: 22px;margin-right: 50px;margin-top: 10px;cursor: pointer;" @click="toItemList({id:4})">更多>></div>
         
        </div>
        <div class="mainBox5">
          <el-row>
            <el-col class="mainBox5_i"  style="display: flex;flex-direction: column;justify-content: center;align-items: center;cursor: pointer;" v-for="(item,index) in jyznList" @click.native="toItemList2(item)" :key="index" :span="6">
              <!-- <img src="../assets/images/shou/icon_3.png" alt=""> -->
              <div class="imgBox" style="margin-top: 30px;">
                <img :src="require('@/assets'+item.imgUrl)" alt="">
              </div>
              <div>{{ item.name }}</div>
            </el-col>
          </el-row>
        </div>
        <div class="mainBox6">
          
          <div class="banshi">
            <vue-seamless-scroll
              :data="myList"
              :class-option="classOption"
              class="warp"
            > 
              <ul class="ul-item">
                <li class="li-item" @click="toItemInfo(item)" v-for="item in myList" :key="item.id">
                  <img :src="toUrl(item.imgUrl)" alt="">
                  <div class="name">{{ item.title }}</div>
                  <div class="title">{{ item.remark }}</div>
                </li>
              </ul>
            </vue-seamless-scroll>
            </div>
        </div>
        <div class="mainBox7">
                <select class="f1" name="friead" onchange="window.open(this.options[this.selectedIndex].value,'_blank')" size="1" ><option selected="selected">国家卫生、医院网站</option><option value="http://www.nhfpc.gov.cn/">国家卫计委</option><option value="http://www.satcm.gov.cn/">国家中医药管理局</option><option value="http://www.301hospital.com.cn/">解放军总医院</option><option value="http://www.pumch.cn/">北京协和医院</option><option value="http://www.cd120.com/">华西医院</option><option value="http://www.pkuph.cn/">北京大学人民医院</option><option value="http://www.zryhyy.com.cn/">中日友好医院</option><option value="http://www.puh3.net.cn/">北京大学第三医院</option><option value="http://www.huashan.org.cn/">复旦大学附属华山医院</option><option value="http://www.rjh.com.cn/2013ruijin/ruijin/sy/index.shtml">上海交大附属瑞金医院</option><option value="http://www.zs-hospital.sh.cn/">复旦大学附属中山医院</option><option value="http://www.bddyyy.com.cn/">北京大学第一医院</option></select>&nbsp;&nbsp;&nbsp;<select class="input" name="friead" onchange="window.open(this.options[this.selectedIndex].value,'_blank')" size="1" style="width: 170px"><option selected="selected">省级医院网站</option><option value="http://www.sph.com.cn/">山东省立医院</option><option value="http://www.qiluhospital.com/">齐鲁医院</option><option value="http://www.sdhospital.com.cn/">山东省千佛山医院</option><option value="http://sdey.net/">山东大学第二医院</option><option value="http://www.bjzhongyi.com/">北京中医医院</option><option value="http://www.zjhtcm.com/">浙江省中医院</option><option value="http://www.jshtcm.com/">江苏省中医院</option><option value="http://www.sdzydfy.com/web/index.asp">山东省中医院</option><option value="www.gdhtcm.com/">广东省中医院</option><option value="http://www.sgyy.cn/">上海曙光医院</option><option value="http://www.longhua.net/">上海龙华医院</option><option value="http://www.dzmyy.com.cn/">北京东直门医院</option><option value="http://www.gamhospital.ac.cn/">北京广安门医院</option><option value="http://www.xyhospital.com/">北京西苑医院</option><option value="http://www.jst-hosp.com.cn/">北京积水潭医院</option></select>&nbsp;&nbsp;&nbsp;<select class="input" name="friead" onchange="window.open(this.options[this.selectedIndex].value,'_blank')" size="1" style="width: 170px"><option selected="selected">地、市医院网站</option><option value="http://www.jnszyyy.com/">济南市中医医院</option><option value="http://www.wfszyy.com/">潍坊市中医院</option><option value="http://www.zxyy.cn/">济南市中心医院</option><option value="http://qyfy.cn/">青岛大学附属医院</option><option value="http://www.ytzyy.cn/">烟台市中医院</option><option value="http://www.hztcm.net/">杭州市中医院</option><option value="http://www.njszyy.cn/">南京市中医院</option><option value="http://www.jyfy.com.cn/">济宁医学院附属医院</option></select>&nbsp;&nbsp;&nbsp;<select class="input" name="friead" onchange="window.open(this.options[this.selectedIndex].value,'_blank')" size="1" style="width: 170px"><option selected="selected">县级医院网站</option><option value="http://www.hdzyy.com.cn/">青岛市黄岛区中医医院</option><option value="http://www.rcszyy.com/">荣成市中医医院</option><option value="http://www.pyxzyyy.com.cn/">平邑县中医医院</option><option value="http://www.zpzyy.com/">邹平县中医院</option><option value="http://www.tzszyyy.com/">滕州市中医医院</option><option value="http://www.thzyy.com/">安徽省太和中医院</option><option value="http://www.wdzgyy.com/">山东省文登整骨医院</option></select>&nbsp;&nbsp;&nbsp;<select class="input" onchange="window.open(this.options[this.selectedIndex].value,'_blank')" size="1" style="width: 170px"><option selected="selected">友情链接</option><!--option value="http://zqzyy.cn/">章丘中医院老网站</option--><option value="http://www.bjzhongyi.com/">北京中医医院</option><option value="http://www.sdhospital.com.cn/">山东省千佛山医院</option><option value="http://www.sdzydfy.com/web/index.asp">山东省中医院</option><option value="http://www.epzyy.com/">解放军二炮医院</option><option value="https://www.sdfmu.edu.cn/">山东省医学科学院</option><option value="http://www.jnzq.gov.cn/">章丘市政府</option><option value="http://www.zqxcw.gov.cn/zqqdz/">章丘区卫生健康局</option><option value="http://www.zqrmyy.net/">章丘市人民医院</option><option value="http://www.zqxcw.gov.cn/jkzx/">章丘市疾控中心</option><option value="http://www.sdjnzqfy.com/">章丘市妇幼保健院</option><option value="http://www.jneye.com.cn/">济南市明水眼科医院</option></select>
  
        </div>
      </div>
      <div class="footBox">
      </div>
      <div class="footter">
        <div>
          <a href="javascript:scroll(0,0)">返回顶部</a>  |   <a href="./about/yyab/1.html" rel="nofollow">关于我们</a>  |   <a href="">技术支持</a>  |   服务热线：{{yyInfo.hosPhone}}
        </div>
        <div>
          <a href="http://beian.miit.gov.cn" target="_blank">{{yyInfo.hosRecord}}</a>    网址：<a href="http://www.zqzyy.cn" title="章丘区中医医院">{{yyInfo.webAddress}}</a>  版权所有：<a href="https://www.zqzyy.cn" title="章丘区中医医院">{{yyInfo.copyInfo}}</a>
        </div>
        <div>
          {{yyInfo.hosName}}地址：{{yyInfo.hosAddress}}
        </div>
        <div>
          <a href="https://bszs.conac.cn/sitename?method=show&id=0A3CD1A8F4107420E053012819ACF59D" target="_blank"><img id="imgConac" vspace="0" hspace="0" border="0" src="https://dcs.conac.cn/image/blue.png" data-bd-imgshare-binded="1"></a>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Swiper from 'swiper'; // 注意引入的是Swiper
  import 'swiper/css/swiper.min.css' // 注意这里的引入
  import axios from 'axios'
  import vueSeamlessScroll from  'vue-seamless-scroll'
  // let baseUrl = 'http://61.156.89.107:7302/prod-api'
  let baseUrl = 'https://www.zqzyy.cn'
  let baseUrl2 = 'https://www.zqzyy.cn'
  export default {
    name: 'HomePage',
    /* eslint-disable */
    components: {
	        vueSeamlessScroll
	  },
    /* eslint-disable */
    data(){
      return{
        // step: 5, // 数值越大速度滚动越快
				// limitMoveNum: 10, // 开始无缝滚动的数据量 this.dataList.length
				// hoverStop: true, // 是否开启鼠标悬停stop
				// direction: 2, // 0向下 1向上 2向左 3向右
				// openWatch: true, // 开启数据实时监控刷新dom
				// singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1 
				// singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				// waitTime: 1000,
        
        listData: [1, 2, 3, 4, 5, 6],
        classOption: {
          step: 1,
          limitMoveNum: 2,
          direction: 2,
        },
        
        xwData:{},
        videe1:'',
        videe2:'',
        bannerList:[],
        yyInfo:{},
        swiper: null,
        //内科
        nkList:[],
        //外科
        wkList:[],
        //骨科
        gkList:[],
        //其他科
        qtkList:[],
        //通知公告列表
        tzggList:[],
        //科研教学列表
        kyjxList:[],
        //党建社群列表
        djsqList:[],
        //新闻动态列表
        xwdtList:[],
        // 轮播图数据
        barList:[],
        jyznList:[
          {id:'1',name:'楼层分布',imgUrl:'/images/shou/icon_2.png',lmId:4},
          {id:'2',name:'医保信息',imgUrl:'/images/shou/icon_6.png',lmId:4},
          {id:'3',name:'急诊须知',imgUrl:'/images/shou/icon_7.png',lmId:4},
          {id:'4',name:'预约挂号',imgUrl:'/images/shou/icon_9.png',lmId:4},
          {id:'5',name:'高新设备',imgUrl:'/images/shou/icon_1.png',lmId:19},
          {id:'6',name:'门诊流程',imgUrl:'/images/shou/icon_8.png',lmId:4},
          {id:'7',name:'特色治疗',imgUrl:'/images/shou/icon_3.png',lmId:4},
          {id:'8',name:'坐诊时间',imgUrl:'/images/shou/icon_5.png',lmId:4},
        ],
        myList:[],
        activeIndex: '1',
      }
    },
    mounted() {
          this.getSwiper()
    },
    created() {
      this.fetchData();
    },
    methods:{
      toGzs(){
        window.open('http://hoaren.com/indexPage', '_blank');
      },
      wkSp(e){
        return e.substring(0,4)
      },
      qtSp(e){
        return e.substring(0,3)
      },
      gkSp(e){
        return e.substring(0,13)
      },
      toUrl(e){
        return baseUrl+e
      },
      toUrl2(e){
        return baseUrl2+e
      },
      spDate(e){
        if(e){
          return e.substring(0,10)
        }
      },
      spDate2(e){
        if(e){
          return e.substring(5,10)
        }
      },
      extractSrcFromImgTag(imgTag) {
          // 使用正则表达式匹配src属性的值
          const regex = /src="([^"]+)"/;
          const match = imgTag.match(regex);
          // 如果匹配成功，返回匹配到的src值；否则返回null
          return match ? match[1] : null;
      },
      fetchData(){
        axios.get('/prod-api/system/info/list?pageNum=1&pageSize=1')
        .then(res => {
          this.yyInfo = res.data.rows[0]
          this.bannerList = this.yyInfo.carouse.split(',').map(item=>{
            return baseUrl+item
          })
        })
        //首页导航
        axios.get('/prod-api/system/lan/list?pageNum=1&pageSize=1000&isCarousel=1')
        .then(res => {
          let newData = { id: 55533, lmName: "首页" };
          this.barList = res.data.rows
          this.barList.unshift(newData)
        })
          //新闻动态
        axios.get('/prod-api/system/fb/list?pageNum=1&pageSize=6&free4=1&free5=新闻动态')
        .then(res => {
          this.xwdtList = res.data.rows
          
        })

        axios.get('/prod-api/system/fb/newTop1')
        .then(res => {
          this.xwData = res.data.data[0]
          if(this.xwData.content){
            const aa = this.extractSrcFromImgTag(this.xwData.content)
            if(aa.indexOf("prod-api") != -1){
              this.xwData.imgUrl2 = aa
            }else{
              this.xwData.imgUrl = aa
            }
           
          }
          
        })
        //党建社群
        axios.get('/prod-api/system/fb/list?pageNum=1&pageSize=5&free4=1&free5=党建社群')
        .then(res => {
          this.djsqList = res.data.rows
        })
        //科研教学
        axios.get('/prod-api/system/fb/list?pageNum=1&pageSize=5&free4=1&free5=科研教学')
        .then(res => {
          this.kyjxList = res.data.rows
        })
        //通知公告
        axios.get('/prod-api/system/fb/list?pageNum=1&pageSize=6&free4=1&free5=通知公告')
        .then(res => {
          this.tzggList = res.data.rows
        })
        //内科
        axios.get('/prod-api/system/fb/list?pageNum=1&pageSize=7&free4=1&free5=科室设置&free1=内科')
        .then(res => {
          this.nkList = res.data.rows
        })
         //外科
         axios.get('/prod-api/system/fb/list?pageNum=1&pageSize=14&free4=1&free5=科室设置&free1=外科')
        .then(res => {
          this.wkList = res.data.rows
        })
        //骨科
        axios.get('/prod-api/system/fb/list?pageNum=1&pageSize=7&free4=1&free5=科室设置&free1=骨科')
        .then(res => {
          this.gkList = res.data.rows
        })
        //其他科
        axios.get('/prod-api/system/fb/list?pageNum=1&pageSize=21&free4=1&free5=科室设置&free1=其他')
        .then(res => {
          this.qtkList = res.data.rows
        })
        //名医介绍
        axios.get('/prod-api/system/fb/list?pageNum=1&pageSize=21&free4=1&free5=名医名家')
        .then(res => {
          this.myList = res.data.rows
        })
        //视频中心
        axios.get('/prod-api/system/fb/list?pageNum=1&pageSize=1&free4=1&free5=视频中心')
        .then(res => {
          let data = res.data.rows[0]
          if(data.videoUrl){
            this.videe1 = baseUrl+res.data.rows[0].videoUrl
          }else if(data.content){
            const aa = this.extractSrcFromImgTag(data.content)
            this.videe2 = aa
          }
        })
      },
      getSwiper() {
          this.swiper = new Swiper(".swiper-container", {
              loop: true, // 无缝
              autoplay: { //自动开始
                  delay: 900, //时间间隔
                  stopOnLastSlide:false,
                  disableOnInteraction: false, //*手动操作轮播图后不会暂停*
              },
              paginationClickable: true,
              slidesPerView: 7, // 一组三个
              // spaceBetween: 30, // 间隔
              // 如果需要前进后退按钮
              navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
              },
              // 窗口变化,重新init,针对F11全屏和放大缩小,必须加
              observer: true,
              observeParents: true,
              // 如果需要分页器
              pagination: {
                  el: '.swiper-pagination',
                  clickable: true, // 分页器可以点击
              },
          })
      },
      toList(){
        if (this.$route.path !== '/ItemList') {
          this.$router.push('/ItemList');
        } else {
          // 如果已经是 /item，则不做任何操作
          console.log('Already at /ItemList');
        }
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      toInfo(e){
        console.log(e)
      },
      toItemInfo(e){
        e.djNum++
        let tdata = e
        localStorage.setItem("paData",JSON.stringify(tdata));
        // this.$router.push({ name: 'itemInfo', params: tdata})
        axios.put('/prod-api/system/fb/djs', tdata).then(()=>{
          this.$router.push({ name: 'itemInfo', params: tdata})
        })
      },
      toItemList(e){
        if(e.id==55533){
          this.$forceUpdate()
        }else{
          let tdata = e
          localStorage.setItem("lmData",JSON.stringify(tdata));
          this.$router.push({ name: 'ItemList', params: tdata})
        }
        
      },
      toItemList2(e){
        let tdata = e
        tdata.id = tdata.lmId
        localStorage.setItem("lmData",JSON.stringify(tdata));
        this.$router.push({ name: 'ItemList', params: tdata})
      },
    },
  }
  </script>
  
  
  <style lang="scss" scoped>
  .el-menu-item{
    border-bottom: none !important;
    &:hover{
      color: #881F0C !important; 
      border-bottom: 4px solid #881F0C !important;
    }  
  }
  // .el-menu-item:hover{
  //   color: #881F0C !important; 
  //   border-bottom: 4px solid #881F0C !important;
  // }
    // .imgBox1{
    //   width: 100%;
    //   height: 100%;
    //   background-image: url('../assets/images/banner/ban01.jpg');
    //   background-size: cover;
    // }
    // .imgBox2{
    //   width: 100%;
    //   height: 100%;
    //   background-image: url('../assets/images/banner/ban02.jpg');
    //   background-size: cover;
    // }
    // .imgBox3{
    //   width: 100%;
    //   height: 100%;
    //   background-image: url('../assets/images/banner/ban03.jpg');
    //   background-size: cover;
    // }
    .mainBox{
      width:70%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
    .mainBox1{
      display: flex;
      justify-content: center;
    }
    .mainBox2{
      width:100%;
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      .mainBox2_1{
        width: 64%;
        height: 100%;
        .mainBox2_1_1{
          width: 100%;
          background-image: url(../assets/images/shou/new-title.jpg);
          background-size: 100% 100%;
          display: flex;
          height: 100px;
          align-items: center;
          color: #fff;
          position: relative;
        }

        // 新闻动态模块
        .mainBox2_1_2{
          display: flex;
          flex-wrap: nowrap;
          margin-top: 10px;
          .m_left{
            width: 7%;
            // height: 200px;
            background-image: url('../assets/images/shou/newsdirr.png');
            background-size: 100% 100%;
            padding-top: 10px;
            min-height: 180px;
          }
          .m_right{
            width: 93%;
            min-height: 180px;
            background-image: url('../assets/images/shou/newsddd1.png');
            background-size: 100% 100%;
            padding-top: 10px;
            display: flex;
            .m_right_l{
              width: 40%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: -20px;
              position: relative;
              img{
                width: 94%;
                height: 170px;
              }
              .imTitle{
                width: 94%;
                height: 30px;
                opacity: 0.7;
                background-color: black;
                color:#fff;
                position: absolute;
                bottom: 10px;
                display: flex;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                align-items: center;
                
              }
              
            }
            .m_right_r{
              width:60%;
              .m_item{
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                padding:4px 0;
                color:#881F0C;
                cursor: pointer;
                &:hover{
                  color: red;
                }
                img{
                  width: 14px;
                  height: 14px;
                }
              }
            }
            
          }
        }
        //党建社群&科研教学模块
        .mainBox2_1_3{
          display: flex;
          flex-wrap: nowrap;
          margin-top: 2px;
          .m_left{
            width: 7%;
            height: 200px;
            background-image: url('../assets/images/shou/newsdirr.png');
            background-size: 100% 100%;
          }
          .m_right{
            width: 93%;
            height: 200px;
            background-image: url('../assets/images/shou/newsddd1.png');
            background-size: 100% 100%;
            display: flex;
            justify-content: space-around;
            .djBox{
              width: 48%;
              padding:10px 0;
              .title{
                font-size: 20px;
                color:#881F0C;
                padding:4px 0 4px 2px;
              }
              .djItem{
                  display: flex;
                  justify-content: space-between;
                  padding:4px 0;
                  color:#881F0C;
                  cursor: pointer;
                  &:hover{
                    color: red;
                  }
                  .djItem-1{
                    display: flex;
                    align-items: center;
                    width:80%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    img{
                      width: 14px;
                      height: 14px;
                    }
                    
                  }
              }
            }
          }
        }
      }
      .mainBox2_2{
        width: 32%;
        height: 100%;
        .bo2_ti{
          width:100%;
          height: 80px;
          background-image: url('../assets/images/shou/video-title.jpg');
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            color: #fff;
            font-weight: 600;
        }
        .bo2_m{
          width: 100%;
          border: 2px solid #881F0C;
          margin-top: 10px;
          margin-bottom: 10px;
          height: 180px;
          .bo2Item{
            display: flex;
            justify-content: space-around;
            padding:5px 10px;
            color: #881F0C;
            cursor: pointer;
            &:hover{
              color: red;
            }
            .bo2ItemTitle{
              width: 80%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .bo2_s{
          width: 100%;
          margin-top: 6px;
          height: 160px;
          border: 1px solid black;
        }
      }
    }
    .mainBox3{
      width: 100%;
      height: 300px;
      background-image: url('../assets/images/shou/cat_bg.jpg');
      background-size: 100% 100%;
      margin-top: 20px;
      display: flex;
      padding:7% 0 5px 0;
      
      div{
        display: flex;
        justify-content: center;
        color:#881F0C;
        .title{
          font-size: 22px;
          font-weight: 550;
          padding-bottom: 20px;
        }
      }
      .mainBox3Box{
        display: block;
        // flex-direction: column;
        .mainBox3BoxMain1{
          display: flex;
          justify-content: space-around;
          flex-wrap: wrap;
          padding:0 10px;
          cursor: pointer;
          &:hover{
            color: red;
          }
          div{
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            padding:6px 0;
          }
        }
        .mainBox3BoxMain2{
          display: flex;
          justify-content: space-around;
          flex-wrap: wrap;
          padding:0 10px;
          cursor: pointer;
          &:hover{
            color: red;
          }
          div{
            width: 50%;
            overflow: hidden;
            white-space: nowrap;
            padding:6px 0;
          }
        }
        .mainBox3BoxMain3{
          display: flex;
          justify-content: space-around;
          flex-wrap: wrap;
          padding:0 10px;
          cursor: pointer;
          &:hover{
            color: red;
          }
          div{
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            padding:6px 0;
          }
        }
        .mainBox3BoxMain4{
          display: flex;
          justify-content: space-around;
          flex-wrap: wrap;
          padding:0 10px;
          cursor: pointer;
          &:hover{
            color: red;
          }
          div{
            width: 30%;
            overflow: hidden;
            white-space: nowrap;
            padding:6px 0;
            // text-align: left;
          }
        }
      }
    }
    .mainBox4{
      width: 100%;
      height: 80px;
      background-image: url('../assets/images/shou/top_bg1.jpg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      
      display: flex;
      justify-content: space-between;
      // padding:20px 70px 0 70px;
      color: #fff;
      align-items: center;
    }
    .mainBox5{
      width: 100%;
      height: 340px;
      border-bottom: 2px solid #881F0C;
      background-color: #f8f4f1;
      .mainBox5_i{
        &:hover{
          font-size: 550;
          color: #881F0C;
        }
      }
    }
    .mainBox6{
      width: 100%;
      height: 300px;
      margin-top: 10px;
      margin-bottom: 10px;
      background-image: url('../assets/images/shou/mingyi_bg.jpg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .mainBox7{
      width: 100%;
      height: 40px;
      background-image: url('../assets/images/shou/top_bg.jpg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .footBox{
      width: 100%;
      height: 20px;
      background-image: url('../assets/images/shou/foot_25.jpg');
    }
    .footter{
      width: 100%;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      padding:30px 0 10px 0;
      background-color: #f8f4f1;
    }
    .banshi {
          width: 78%;
          
          margin: 0 auto;
          padding: 0 0 0 84px;
          .warp {
            width: 100%;
            height: 280px;
            margin: 0 auto;
            overflow: hidden;
            ul {
              list-style: none;
              padding: 0;
              margin: 0 auto;
              
              &.ul-item {
                display: flex;
                
                .li-item {
                  width: 120px;
                  height: 280px;
                  margin-right: 10px;
                  color: black;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  &:hover{
                    color: red;
                    cursor: pointer;
                  }
                  img{
                    width: 120px;
                    height: 180px;
                  }
                  .name{
                    height: 30px;
                    font-size: 24px;
                    font-family: 楷体;
                    color:#881F0C;
                  }
                  .title{
                    height: 20px;
                    font-size: 14%;
                    color:#881F0C;
                  }
                }
              }
            }
          }
      }


     

      
  </style>
  
  